import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import common translations
import enCommon from "./locales/en/common.json";
import arCommon from "./locales/ar/common.json";

// Import dashboard translations
import enDashboard from "./locales/en/dashboard.json";
import arDashboard from "./locales/ar/dashboard.json";

// Import sidebar translations
import enSidebar from "./locales/en/sidebar.json";
import arSidebar from "./locales/ar/sidebar.json";

// Import login translations
import enLogin from "./locales/en/login.json";
import arLogin from "./locales/ar/login.json";

// Import user management translations
import enUserManagement from "./locales/en/usermanagement.json";
import arUserManagement from "./locales/ar/usermanagement.json";

// Import customers translations
import enCustomers from "./locales/en/customers.json";
import arCustomers from "./locales/ar/customers.json";

// Import profile translations
import enProfile from "./locales/en/profile.json";
import arProfile from "./locales/ar/profile.json";

// Import templates translations
import enTemplates from "./locales/en/templates.json";
import arTemplates from "./locales/ar/templates.json";

// Import reports translations
import enReports from "./locales/en/reports.json";
import arReports from "./locales/ar/reports.json";

// Import posters translations
import enPosters from "./locales/en/posters.json";
import arPosters from "./locales/ar/posters.json";

// Import tutorial translations
import enTutorial from "./locales/en/tutorial.json";
import arTutorial from "./locales/ar/tutorial.json";

// Merge translations by language
const enTranslations = {
  ...enCommon,
  ...enDashboard,
  ...enSidebar,
  ...enLogin,
  ...enUserManagement,
  ...enCustomers,
  ...enProfile,
  ...enTemplates,
  ...enReports,
  ...enPosters,
  ...enTutorial
};

const arTranslations = {
  ...arCommon,
  ...arDashboard,
  ...arSidebar,
  ...arLogin,
  ...arUserManagement,
  ...arCustomers,
  ...arProfile,
  ...arTemplates,
  ...arReports,
  ...arPosters,
  ...arTutorial
};

// Set default language to English in localStorage if not set
if (!localStorage.getItem('preferredLanguage')) {
  localStorage.setItem('preferredLanguage', 'en');
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem('preferredLanguage') || "en",
    fallbackLng: "en",
    detection: {
      order: ['localStorage'],
      caches: ['localStorage']
    },
    supportedLngs: ["en", "ar"],
    resources: {
      en: { translation: enTranslations },
      ar: { translation: arTranslations }
    },
    interpolation: {
      escapeValue: false
    }
  });

// 🔁 RTL / LTR switch - Apply immediately and persistently
const applyDirection = (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
  document.body.dir = dir;
  document.body.lang = lng;
};

// Apply on init
applyDirection(i18n.language);

// Apply on language change
i18n.on("languageChanged", (lng) => {
  applyDirection(lng);
});

export default i18n;
